import Icon from '../components/Icon.vue'

Icon.register({"genderless":{"width":1280,"height":1792,"paths":[{"d":"M1024 960q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1152 960q0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/genderless.js
// module id = 1426
// module chunks = 0